

export const featureCardData = [
  {
    heading: "STUDIO.STORE_CLUSTERING",
    id: "fourth",
    key: "clustering",
    image: "icon-store-clustering.svg",
    description: "STUDIO.STORE_CLUSTERING_DESC",
    show: false, // The card is hidden for now and may be enabled later.
  },
  {
    heading: "STUDIO.ASSORTMENT",
    id: "fourth",
    key: "assortment",
    image: "icon-product-feature.svg",
    description: "STUDIO.ASSORTMENT_DESC",
    show: true,
  },
  {
    heading: "STUDIO.PLANOGRAM",
    id: "fifth",
    key: "plano",
    image: "icon-planogram.svg",
    description: "STUDIO.PLANOGRAM_DESC",
    show: true,
  },
  {
    heading: "STUDIO.BULK_OPERATIONS",
    id: "ninth",
    key: "bulk",
    image: "icon-bulk-opration.svg",
    description:
      "STUDIO.BULK_OPERATIONS_DESC",
    show: true,
  },
  {
    heading: "STUDIO.LIBRARIES",
    id: "ninth",
    key: "libraries",
    image: "icon-product-library.svg",
    description:
      "STUDIO.LIBRARIES_DESC",
    show: true,
  },
  {
    heading: "STUDIO.DASHBOARD",
    id: "tenth",
    key: "dashboard-view",
    image: "icon-plano-dashboard-active.svg",
    description: "STUDIO.DASHBOARD_DESC",
    show: true,
  },
  {
    heading: "STUDIO.AI_IMAGERY",
    id: "tenth",
    key: "ai-imagery",
    image: "icon-plano-dashboard-active.svg",
    description: "STUDIO.AI_IMAGERY_DESC",
    show: true,
  },
];

export const librariesCardData = [
  {
    heading: "STUDIO.PRODUCT_LIBRARY",
    id: "first",
    key: "product-library",
    image: "icon-product-library.svg",
    route: "/product-library",
    description: "STUDIO.PRODUCT_LIBRARY_DESC",
    show: true,
  },
  {
    heading: "STUDIO.FIXTURE_LIBRARY",
    id: "second",
    key: "fixture-library",
    image: "icon-product-library.svg",
    route: "/fixture-library",
    description: "STUDIO.FIXTURE_LIBRARY_DESC",
    show: true,
  },
];

